export default "__VITE_ASSET__BgIg_7op__"